import { render, staticRenderFns } from "./CustomerInfoSelfImages.vue?vue&type=template&id=60a6ac2f"
import script from "./CustomerInfoSelfImages.vue?vue&type=script&lang=js"
export * from "./CustomerInfoSelfImages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports